import React from "react";
import { W_STATUS, useWalletT } from "@/lib/wallet";

export const StatusChip = ({ status, testId, small = false }) => {
  const { tw } = useWalletT();
  const st = W_STATUS[status] || W_STATUS.requested;
  const Icon = st.icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-semibold shrink-0 ${small ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]"}`}
      style={{ background: st.bg, color: st.color }} data-testid={testId} data-status={status}>
      <Icon size={small ? 10 : 12} className={status === "processing" ? "animate-spin" : ""} /> {tw(st.key, st.fr)}
    </span>
  );
};

// Vertical timeline of a withdrawal's `history` entries (oldest first).
export const WithdrawalTimeline = ({ history = [], testId }) => {
  const { tw, date } = useWalletT();
  if (!history.length) return null;
  return (
    <ol className="space-y-1.5 mt-2" data-testid={testId}>
      {history.map((h, i) => {
        const st = W_STATUS[h.status] || W_STATUS.requested;
        return (
          <li key={i} className="flex items-start gap-2 text-[11px]" data-testid={testId ? `${testId}-${i}` : undefined}>
            <span className="mt-1 h-2 w-2 rounded-full shrink-0" style={{ background: st.color }} />
            <span style={{ color: "var(--yalola-text-muted)" }}>
              <b style={{ color: "var(--yalola-text)" }}>{tw(st.key, st.fr)}</b> · {date(h.at, true)}
              {h.note && <> · {h.note}</>}
              {h.payment_reference && <> · {tw("wallet.reference", "Référence : {ref}", { ref: h.payment_reference })}</>}
            </span>
          </li>
        );
      })}
    </ol>
  );
};
